<nav id="sidebar">
    <div class="logo py-3 text-center">
        <div class="img w-100 mb-3"></div>
        <p class="text-center welcome mt-4 mb-0">{{ 'greeting' | translate }}</p>
        <p *ngIf="email" class="text-center email">({{email}})</p>
        <div class="text-center mt-2">
            <button (click)="logout()" type="button" class="btn-custom logout">Logout</button>
        </div>
    </div>
    <div class="border-top">
        <h6 class="menu">Mein Profil</h6>
        <ul class="list-unstyled">
            <li class="menu-item border-bottom" routerLinkActive="link-active">
                <a routerLink="cv-detail/de" class="btn pt-0 w-100">Mein Profil in Deutsch</a>
            </li>
            <li class="menu-item border-bottom" routerLinkActive="link-active">
                <a routerLink="cv-detail/en" class="btn pt-0 w-100">Mein Profil in Englisch</a>
            </li>
<!--             <li class="menu-item border-bottom"><a routerLink="upload/de" class="btn">Parsen CV Deutsch</a></li>
            <li class="menu-item border-bottom"><a routerLink="upload/en" class="btn">Parsen CV Englisch</a></li> -->
        </ul>
    </div>
    <div class="border-top border-bottom">
        <h6 class="menu">Berater CVs</h6>
        <ul class="list-unstyled">
            <li class="menu-item border-bottom">
                <a routerLink="cv-list" class="btn pt-0 w-100">Meine CVs</a>
            </li>
        </ul>
    </div>
    <div *ngIf="showSearch" class="search">
        <h6 class="menu">Suchfunktion</h6><ul class="list-unstyled">
            <li class="menu-item border-bottom">
                <a routerLink="search" class="btn pt-0 w-100">Profile durchsuchen</a>
            </li>
        </ul>
    </div>
    <div class="fixed-bottom text-center py-1 dsgvo border">
        <a href="https://www.greybee.de/impressum/" target="_blank" class="impress"> Impressum</a>
        |
        <a href="https://www.greybee.de/datenschutzerklaerung/" target="_blank" class="impress">Datenschutz</a>
    </div>
</nav>
